import { Entity } from "./entity";
import { CONFIG, GameConfig } from "./config";
import { clamp } from "./utils";
import { drawSprite, PLAYER_SPRITE } from "./sprites";

export class Player extends Entity {
  private cooldown = 0;
  private readonly cfg: GameConfig;

  constructor(cfg: GameConfig = CONFIG) {
    super(
      (cfg.canvas.width - cfg.player.width) / 2,
      cfg.player.y,
      cfg.player.width,
      cfg.player.height
    );
    this.cfg = cfg;
  }

  /** `dir`: -1 left, +1 right, 0 idle. */
  update(dt: number, dir: number): void {
    this.x = clamp(
      this.x + dir * this.cfg.player.speed * dt,
      0,
      this.cfg.canvas.width - this.width
    );
    if (this.cooldown > 0) this.cooldown -= dt;
  }

  canFire(): boolean {
    return this.cooldown <= 0;
  }

  /** Starts the cooldown and returns the muzzle position for a new bullet. */
  fire(): { x: number; y: number } {
    this.cooldown = this.cfg.player.fireCooldown;
    return {
      x: this.x + this.width / 2 - this.cfg.bullet.width / 2,
      y: this.y,
    };
  }

  reset(): void {
    this.x = (this.cfg.canvas.width - this.width) / 2;
    this.cooldown = 0;
  }

  draw(ctx: CanvasRenderingContext2D): void {
    drawSprite(
      ctx,
      PLAYER_SPRITE,
      this.x,
      this.y,
      this.cfg.player.spriteScale,
      this.cfg.colors.player
    );
  }
}
